import React from 'react';
import { TopBar } from '../components/TopBar';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Mechanism } from '../components/Mechanism';
import { Timeline21Days } from '../components/Timeline21Days';
import { WhatIncludes } from '../components/WhatIncludes';
import { OfferSection } from '../components/OfferSection';
import { Benefits } from '../components/Benefits';
import { Testimonials } from '../components/Testimonials';
import { Objections } from '../components/Objections';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { StickyCTA } from '../components/StickyCTA';
import { RecentPurchasePopup } from '../components/RecentPurchasePopup';
export function LandingPage() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-235">
      <TopBar data-id="element-236" />

      <main className="flex-grow" data-id="element-237">
        <Hero data-id="element-238" />
        <PainPoints data-id="element-239" />
        <Mechanism data-id="element-240" />
        <Timeline21Days data-id="element-241" />
        <WhatIncludes data-id="element-242" />
        <OfferSection data-id="element-243" />
        <Benefits data-id="element-244" />
        <Testimonials data-id="element-245" />
        <Objections data-id="element-246" />
        <FAQ data-id="element-247" />
        <FinalCTA data-id="element-248" />
      </main>

      <footer className="bg-[#1a0625] text-white/30 py-8 text-center text-sm" data-id="element-249">
        <p data-id="element-250">
          © {new Date().getFullYear()} El Secreto de la Abundancia. Todos los
          derechos reservados.
        </p>
      </footer>

      <StickyCTA data-id="element-251" />
      <RecentPurchasePopup data-id="element-252" />
    </div>;
}